<template>
    <div class="expandMenu" :style="{width: `${width}px`, top: top}" :class="{left: left, right: right, blue: blue, purple: purple}">
        <template v-for="item in value" :key="item">
            <button v-if="item.type == 'button'" class="item"  :class="{disable: item.disable}" @click="btnEvt(item.emit)">
                <img :src="item.image" v-if="item.image">
                {{item.id}}
            </button>

            <label v-if="item.type == 'file'" class="item" @click="close">
                <input @change="loadEvt" type="file" 
                    @input="fileEvt(item.emit, $event)" 
                    @click="$event.target.value = ''"> <!-- accept='.zip' -->
                <img :src="item.image" >
                {{item.id}}
            </label>

            <div v-if="item.type == 'line'" class="line"/>

            <a v-if="item.type == 'link'" class="item" :href="item.href" target="_blank" @click="close">
                <img :src="item.image" >
                {{item.id}}
            </a>

        </template>
    </div>
</template>

<script>
export default {
    name: "SubMenu",
    props: {
        value: {
            type: Array,
            default: () => [
                {id: 'Button', type: 'button'},
                {type: 'line'},
                {id: 'File', type: 'file'},
                {id: 'Link', type: 'link', href:'https://itrain.eduairsz.xyz'},
            ]
        },
        width: {
            type: Number,
            default: 200
        },
        top: {
            type: String,
            default: 'calc(100% + 25px)'
        },
        right: {
            type: Boolean,
            default: false
        },
        left: {
            type: Boolean,
            default: false
        },
        blue: {
            type: Boolean,
            default: false,
        },
        purple: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        close(){
            this.$emit('close')
        },
        fileEvt(emit, event){
            this.$emit(emit, event) 
            this.close();
        },
        btnEvt(emit){
            this.$emit(emit) 
            this.close();
        }
    }
}
</script>

<style scoped>

.expandMenu{
    width: 200px; height: max-content; 
    background: white; position: absolute; 
    top: calc(100% + 25px); 
    z-index: 1; box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; 
    padding: 5px;
}

.left{
    left: 0;
}

.right{
    right: 0;
}

.expandMenu .item{
    width: 100%; height: 32px;
    padding: 0 10px; font-size: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    position: relative;
    text-decoration: none;
    max-width: 100%;

    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;    /* Firefox, other Gecko */
    box-sizing: border-box;         /* Opera/IE 8+ */

    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    -o-border-radius: 5px;
    background: white;
    outline: none;
    border: 2px solid white;
}

.expandMenu .item.disable{
    filter:grayscale(1);
    cursor: default;
    pointer-events: none;
}

.expandMenu img{
    height: 60%;
}

.expandMenu .line{
    width: 100%; height: 1px; background: #dadada; margin: 8px 0;
    border-radius: 0.5px;
}

input[type=file]{
    display: none;
}

.expandMenu .item{
    color: #000; 
}

.expandMenu .item:not(.disable):not(.select):active{
    border: 2px solid #000;
}

.expandMenu .item:not(.disable):not(.select):hover{
    background: #f1f1f1;
}

.expandMenu.blue .item{
    color: #1967D2; 
}

.expandMenu.blue .item:not(.disable):not(.select):active{
    border: 2px solid #1967D2;
}

.expandMenu.blue .item:not(.disable):not(.select):hover{
    background: #E8F0FE;
}

.expandMenu.blue img{
    filter: invert(22%) sepia(92%) saturate(1713%) hue-rotate(202deg) brightness(110%) contrast(90%);
}

.expandMenu.purple .item{
    color: #8A66C7; 
}

.expandMenu.purple .item:not(.disable):not(.select):active{
    border: 2px solid #8A66C7;
}

.expandMenu.purple .item:not(.disable):not(.select):hover{
    background: #fae8fe;
}

.expandMenu.purple img{
    filter: invert(45%) sepia(30%) saturate(959%) hue-rotate(221deg) brightness(95%) contrast(87%);
}
</style>